import {isArray, isObject} from 'lodash';

export class ObjectUtil {
    public static compact(obj: any, options: { removeEmptyString?: boolean } = {}): any {
        if (isArray(obj)) {
            const ouput: any[] = [];
            obj.forEach((value) => {
                value = ObjectUtil.compact(value, options);
                if ((isArray(value) && value.length > 0)
                    || (isObject(value) && Object.keys(value).length > 0)
                    || (value !== undefined && value !== null && !isArray(value) && !isObject(value))) {
                    ouput.push(value);
                }
            });

            return ouput;
        } else if (isObject(obj)) {
            const ouput: any = {};
            Object.keys(obj).forEach((key) => {
                let value: any = (obj as any)[key];
                if (isArray(value) || isObject(value)) {
                    value = ObjectUtil.compact(value, options);
                    if ((isArray(value) && value.length > 0)
                        || (isObject(value) && Object.keys(value).length > 0)
                        || (value !== undefined && value !== null && !isArray(value) && !isObject(value))) {
                        ouput[key] = value;
                    }
                } else if (value !== undefined && value !== null
                    && (typeof value !== 'string' || options.removeEmptyString === false || value.length > 0)) {
                    ouput[key] = value;
                }
            });

            return ouput;
        }

        return (typeof obj !== 'string' || options.removeEmptyString === false || obj.length > 0) ? obj : undefined;
    }

    public static update(source: Record<string, unknown>, target: Record<string, unknown>): void {
        if (typeof source !== 'object' || source === null || typeof target !== 'object' || target === null) {
            return;
        }

        // eslint-disable-next-line no-restricted-syntax
        for (const key in source) {
            if (Object.prototype.hasOwnProperty.call(source, key)) {
                delete source[key]
            }
        }
        Object.assign(source, target)
    }
}
